<template>
  <div>
    <input type="hidden" :name="name" :value="code">
    <HtmlEditor @change="change" :value="code"></HtmlEditor>
  </div>
</template>

<script>
import HtmlEditor from './HtmlEditor'

export default {
  components: {
    HtmlEditor,
  },
  props: ['html', 'name'],
  data() {
    return {
        code: this.html || '',
    }
  },
  mounted() {
  },
  methods: {
    change(html) {
      this.code = html
    },
  },
}
</script>
<style></style>
